import { render, staticRenderFns } from "./RepairCatalog.vue?vue&type=template&id=82707912"
import script from "./RepairCatalog.vue?vue&type=script&lang=js"
export * from "./RepairCatalog.vue?vue&type=script&lang=js"
import style0 from "./RepairCatalog.vue?vue&type=style&index=0&id=82707912&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports